/**
 * @generated SignedSource<<4b80771841e3551fb1a391c20a9379e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserAdminCreateGroupDeviceAcceptRequestRejectMutation$variables = {
  deviceCode: string;
};
export type UserAdminCreateGroupDeviceAcceptRequestRejectMutation$data = {
  readonly store: {
    readonly rejectSharedMobileDeviceAuthRequest: {
      readonly deviceCode: string;
    };
  };
};
export type UserAdminCreateGroupDeviceAcceptRequestRejectMutation = {
  response: UserAdminCreateGroupDeviceAcceptRequestRejectMutation$data;
  variables: UserAdminCreateGroupDeviceAcceptRequestRejectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "deviceCode"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "deviceCode",
            "variableName": "deviceCode"
          }
        ],
        "concreteType": "SharedMobileDeviceAuthRequest",
        "kind": "LinkedField",
        "name": "rejectSharedMobileDeviceAuthRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deviceCode",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserAdminCreateGroupDeviceAcceptRequestRejectMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserAdminCreateGroupDeviceAcceptRequestRejectMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "eb2bdf166402a27c3200b30ee1e1fc3c",
    "id": null,
    "metadata": {},
    "name": "UserAdminCreateGroupDeviceAcceptRequestRejectMutation",
    "operationKind": "mutation",
    "text": "mutation UserAdminCreateGroupDeviceAcceptRequestRejectMutation(\n  $deviceCode: String!\n) {\n  store {\n    rejectSharedMobileDeviceAuthRequest(deviceCode: $deviceCode) {\n      deviceCode\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "669aeb08a82c7509ad3301a310326c0e";

export default node;
